import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ReactComponent as LimitMEdit } from '../../../../assets/counterparty_edit.svg'
import { Box, Menu } from '@mui/material'
import { ButtonSaveStyleLimitM, TextStyleTradingAccount } from '../ClientMmDetails.style'
import { useEffect } from 'react'

const TradingAccountMenu = ({ form, setForm, userType }) => {
  useEffect(() => {
    setCounterparty({
      shortname: form.shortname,
      client_name: form.client_name,
      market_maker_name: form.market_maker_name
    })
  }, [form.shortname, form.client_name, form.market_maker_name])

  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [counterparty, setCounterparty] = useState(form)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handelChange = event => {
    const { name, value } = event.target
    setCounterparty({ ...counterparty, [name]: value })
  }

  const handelSubmit = async () => {
    setForm(prev => ({ ...prev, ...counterparty }))
    handleClose()
  }

  const disabled = () => {
    if (
      form.shortname === counterparty.shortname &&
      form.client_name === counterparty.client_name &&
      form.market_maker_name === counterparty.market_maker_name
    ) {
      return true
    }
    return false
  }

  return (
    <>
      <LimitMEdit
        style={{ marginLeft: '10px' }}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      ></LimitMEdit>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        style={{
          padding: '24px'
        }}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
          background: '#242428',
          boxShadow: '-2px 2px 4px 1px rgba(0, 0, 0, 0.50)',
          borderRadius: '8px'
        }}
      >
        <Box
          style={{
            display: 'flex',
            gap: '8px',
            flexDirection: 'column',
            padding: '8px'
          }}
        >
          <TextStyleTradingAccount
            placeholder="Enter Counterparty"
            name={userType === 'client' ? 'client_name' : 'market_maker_name'}
            value={counterparty?.client_name || counterparty?.market_maker_name}
            onChange={handelChange}
          />
          <TextStyleTradingAccount
            placeholder="Enter Shortname"
            name="shortname"
            value={counterparty?.shortname}
            onChange={handelChange}
          />
          <ButtonSaveStyleLimitM onClick={handelSubmit} disabled={disabled()}>
            OK
          </ButtonSaveStyleLimitM>
        </Box>
      </Menu>
    </>
  )
}

export default TradingAccountMenu

TradingAccountMenu.propTypes = {
  form: PropTypes.string,
  setForm: PropTypes.func,
  userType: PropTypes.string
}
